module.exports = __webpack_public_path__ + "static/img/policy-manual-wizard.83326de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/policy-manual-wizard.png
// module id = wZ4o
// module chunks = 0